import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/auth/auth.service';
import { BranchMatserService } from 'app/masters/branch-matser.service';

@Component({
  selector: 'app-reports-header-footer',
  templateUrl: './reports-header-footer.component.html',
  styleUrls: ['./reports-header-footer.component.scss']
})
export class ReportsHeaderFooterComponent implements OnInit {

  constructor(public branchMatserService :BranchMatserService, public authService :AuthService,) { }

  ngOnInit(): void {
    this.getBranchDetail(this.authService.Loggeduser.branchid);
  }
  branchmansterObj:any={};
    getBranchDetail(id){
      this.branchmansterObj={};
      this.branchMatserService.getBrachMasterItem(id).subscribe((x:any)=>{
        this.branchmansterObj =x[0];
      })
    }
}
